var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarYellowpng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    transform: "translate(0.919922 0.859985)",
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1792_458",
    transform: "scale(0.0625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1792_458",
    width: 16,
    height: 16,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAWQAAAFkBqp2phgAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAFTSURBVDiNlZI/S0JhFMZ/50XvvVHklEUEtho15SCBguBUUzQ4C0HfwaEp8Cv4HWpuadDr5NIgUY1BVKhQ0nCJvHRPQxrX8u/Zznmf53l/L+eFCaU1p6g1pzhJI2PN9aUV1H8EBD+SkLzXHqUz46/vnQAOYBP1j+ci0CoRjP0AbPRHLyx+bkoKfzYCYx2FzADreNbhSAJ17X1U0hhdQ1kFjYMkgdgf7TvoPUgHoU0gLUQboq7dBuLj3jilOoZACiDd+b3SJZCCAGjd2gK5REnM6H7GBAeS8ZsGQLK9O74iaZDrGcw3BCYtGb8JoS1Izmshwdl0cj2V3MfToB1eYyB7UwPUpMPtcIAwPQAd0vwG6C0WsBs68xAtIVoCvNA81df+IXiL7vDz90HkHExSsr2yZHtlMEmUi75ygdfo9n+wK2Lq2hWtOvmx8FUnr65d0QbLg9k3QflombXow/oAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarYellowpng);
export default __webpack_public_path__ + "static/media/star-yellow.png.7af597820f01898b51e25d1dcb86463c.svg";
export { ForwardRef as ReactComponent };